module.exports = __webpack_public_path__ + "static/media/promotion-66-percent.0336acf3.png";